import { IExperimentsProviderProps } from './interfaces';
import {
  getChallengesExperiments,
  isDisabled,
  isEnabled,
} from '../../services/experiments';
import { ControllerFlowAPI } from 'yoshi-flow-editor-runtime/build/cjs/flow-api/ViewerScript';

let experimentsService;

export const experimentsProviderPropsMap = async (
  flowAPI: ControllerFlowAPI,
): Promise<IExperimentsProviderProps> => {
  if (experimentsService) {
    return experimentsService;
  }
  const { isViewer } = flowAPI.environment;
  const biAPI = flowAPI.controllerConfig.platformAPIs.bi;
  const siteOwnerId = biAPI.ownerId;
  const ctx = {};

  if (isViewer) {
    ctx['forSiteVisitors'] = { siteOwnerId, visitorId: biAPI.visitorId };
  } else {
    ctx['forSiteOwner'] = {
      siteOwnerId,
      loggedInUserId: flowAPI.controllerConfig.wixCodeApi.user?.currentUser?.id,
    };
  }

  const experiments = await getChallengesExperiments({
    enableNewApi: true,
    ctx,
    baseUrl: 'https://www.wix.com/_api/challenges-web-proxy/experiments',
  });

  experimentsService = {
    experiments,
    disabled(experiment): boolean {
      return isDisabled(experiments[experiment]);
    },
    enabled: (experiment): boolean => {
      return isEnabled(experiments[experiment]);
    },
  };
  return experimentsService;
};
